//import AppSettings from '../appSettings'
class GeneralUtil {
    static handleError(error, innerError) {
        let s = error instanceof Error ? error.message : error.toString();
        const innerS = innerError instanceof Error ? innerError.message : innerError === null || innerError === void 0 ? void 0 : innerError.toString();
        if (innerS)
            s += `
${innerS}`;
        console.log(s);
        //if (AppSettings.SHOW_ERROR_ALERTS)
        alert(s);
    }
    static log(text, someObject = "") {
        const objS = someObject ?
            someObject.toString() :
            someObject == "" ?
                "" :
                "nothing";
        console.log(`${text} ` + objS);
    }
    static getNow() {
        return GeneralUtil.FAKE_NOW ? GeneralUtil.FAKE_NOW : new Date();
    }
}
GeneralUtil.FAKE_NOW = null;
export default GeneralUtil;
